import DashboardWidgetSettings from "@/domain/entities/user/DashboardWidgetSettings";
import { DashboardWidgetSettings as DashboardWidgetSettingsSDK } from "@cs_teamwaydev/mailvista-sdk_react";

export const dashboardWidgetSettingsToDomainMapper = (
    dashboardWidgetSettings: DashboardWidgetSettingsSDK,
): DashboardWidgetSettings =>
    new DashboardWidgetSettings({
        showCalendar: dashboardWidgetSettings.showCalendar,
        showTodo: dashboardWidgetSettings.showTodo,
        showCOImpact: dashboardWidgetSettings.showCOImpact,
        showRepartition: dashboardWidgetSettings.showRepartition,
        showTipofTheDay: dashboardWidgetSettings.showTipofTheDay,
        showDailyMood: dashboardWidgetSettings.showDailyMood,
        showNotepad: dashboardWidgetSettings.showNotepad,
        showMeteo: dashboardWidgetSettings.showMeteo,
    });

export const dashboardWidgetSettingsToSDKMapper = (
    dashboardWidgetSettings: DashboardWidgetSettings,
): DashboardWidgetSettingsSDK => ({
    showCalendar: dashboardWidgetSettings.showCalendar,
    showTodo: dashboardWidgetSettings.showTodo,
    showRepartition: dashboardWidgetSettings.showRepartition,
    showTipofTheDay: dashboardWidgetSettings.showTipofTheDay,
    showDailyMood: dashboardWidgetSettings.showDailyMood || true,
    showNotepad: dashboardWidgetSettings.showNotepad || true,
    showMeteo: dashboardWidgetSettings.showMeteo || true,
    showCOImpact: dashboardWidgetSettings.showCOImpact || true,
});
